import * as React from 'react';
import styled from '@emotion/styled';
import { colors } from 'styles/colors';
import './Card.css';

interface CardProps {
  children: React.ReactChild;
  lightShadow?: boolean;
  onClick?: () => any;
}

export const Card = ({ children, lightShadow, onClick }: CardProps) => {
  return (
    <div
      className='card-container'
      onClick={onClick}
      style={{
        ...(!!lightShadow && { boxShadow: '0 0 10px hsla(0, 0%, 0%, 0.06)' })
      }}>
      {children}
    </div>
  );
};
